import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../../modal/detail-modal/default-container/default-container';
import { CreateMasterPinCodeModal } from '../create-master-pin-code-modal/create-master-pin-code-modal.component';
import { UpdateMasterPinCodeModal } from '../update-master-pin-code-modal/update-master-pin-code-modal.component';
import { useMasterPinCodeContainer } from './master-pin-code-container.controller';

export interface MasterPinCodeContainerProps {
    iot_id: string;
}

export const MasterPinCodeContainer = (props: MasterPinCodeContainerProps) => {
    const viewProps = useMasterPinCodeContainer(props);
    return (
        <DefaultContainer
            styles={{ container: 'w-99/200' }}
            title={CommonMessage.OBJECTS.RAKINDA.MASTER_PIN_CODE}
            content={
                <div>
                    {viewProps.pinCode ? (
                        viewProps.pinCode.code
                    ) : (
                        <FormattedMessage
                            id='APPLICATIONS.RAKINDA.NO_MASTER_PIN_CODE'
                            defaultMessage='No Master PIN-code'
                        />
                    )}
                </div>
            }
            update={{
                onUpdate: () =>
                    viewProps.openModal(
                        viewProps.MASTER_PIN_CODE_MODAL_ID,
                        () =>
                            viewProps.pinCode ? (
                                <UpdateMasterPinCodeModal
                                    pin_code_id={viewProps.pinCode.id}
                                    callback={viewProps.setPinCode}
                                />
                            ) : (
                                <CreateMasterPinCodeModal
                                    entity_id={props.iot_id}
                                    callback={viewProps.setPinCode}
                                />
                            ),
                        {},
                        {}
                    )
            }}
        />
    );
};
